<div class="multi-select-container" [class.fit-content]="widthFitContent">
  <div class="container-esquerdo" [class.show-options]="showOptions">
    <div class="options-container">
      <label *ngIf="title" class="label-texto">{{ title }}</label>
      <div class="novo-select" [class.fit-content]="widthFitContent" [class.primary]="primaryStyle" (click)="changeOptions()">
        <i *ngIf="icon" [ngClass]="icon"></i>
        <div class="select" id="select" name="texto" class="input-texto" required="required" aria-required="true">{{ placeholderText }}</div>
        <i class="fas select-icon" [ngClass]="showOptions ? 'fa-chevron-up' : 'fa-chevron-down'" ></i>
      </div>
    </div>

    <div id="checkboxes" class="checkboxes" *ngIf="showOptions">
      <label
        *ngFor="let item of list"
        class="checkbox-container"
        id="conectado-lista"
      >
        <input
          type="checkbox"
          id="conectado-select"
          [checked]="item.selected"
          (click)="onSelect($event, item)"
        />
        <span id="conectado" class="checkmark checkmark-margen"></span>
        <span id="conectado-name" class="label-checkbox">{{ item.nome }}</span>
      </label>
    </div>
  </div>

  <div *ngIf="showSelectedList && selectedlist.length > 0" class="content-direito">
    <div class="chip-container">
      <div *ngFor="let item of selectedlist" class="chip">
        <span class="label">{{ item.nome }}</span>
        <i class="far fa-times" name="delete" (click)="onValue(item)"></i>
      </div>
    </div>
  </div>
</div>
